export default __webpack_public_path__ + "static/media/Alpha_ketoanalogue.10a479d4.jpg";